import { useLocation } from 'react-router-dom'
import { fullNameGenerator } from '../../tools'
import { FormatDate } from '../../../../utils/common'
import { getStatesForRescheduleVisit } from '../helpers/getStatesForRescheduleVisit'
import { getVisitMethodOptionFromVisitMethod } from '../../../new-visit/components/visit-information/VisitMethods'
import { useServiceTypes } from '@/hooks/useServiceTypes'

export const useRescheduleLocationState = () => {
  const { state: locationState } = useLocation()

  const { serviceTypes } = useServiceTypes()

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const getRescheduleLocationState = (visitDetailsInfo, customTimeZone) => {
    const { VisitId, VisitTypeName, FromDateTime, ServiceTypeName, Method, StateCode } = visitDetailsInfo
    const providerInfo = visitDetailsInfo?.Provider
    const patientInfo = visitDetailsInfo?.Patient

    return {
      provider: {
        ImageUrl: providerInfo?.ImageUrl,
        providerId: providerInfo?.UserId,
        providerName: fullNameGenerator(providerInfo || {}),
      },
      patient: {
        patientId: patientInfo?.PatientId,
        address: patientInfo?.Address,
        phoneNumber: patientInfo?.PhoneNumber,
        fullName: fullNameGenerator(patientInfo || {}),
        birthDate: patientInfo?.BirthDate,
        gender: patientInfo?.Gender,
        email: patientInfo?.Email,
      },
      previousState: { ...locationState, openCalendarDetails: false },
      bookingId: VisitId,
      // Same value as bookingId, under the name that says what it is: the visit being rescheduled.
      // Sent as RescheduleVisitId on the availability search so the backend can pin in-person slots
      // to that visit's treatment center.
      rescheduleVisitId: VisitId,
      visitType: `${ServiceTypeName} (${VisitTypeName})`,
      visitMethod: getVisitMethodOptionFromVisitMethod(Method),
      visitTimeZone: visitDetailsInfo.TimeZone || customTimeZone,
      visitTime: visitDetailsInfo.FromDateTime,
      visitStateCode: StateCode,
      availableStateCodes: getStatesForRescheduleVisit({
        licensesList: providerInfo?.Licenses,
        serviceTypesList: serviceTypes,
        serviceTypeName: ServiceTypeName,
        visitTypeName: VisitTypeName,
      }),
      clickedDateTime: {
        displayDate: FormatDate(FromDateTime, 'Date', customTimeZone),
        displayTime: FormatDate(FromDateTime, 'Time', customTimeZone),
      },
      customTimeZone,
      useDateTime: true,
    }
  }

  return { getRescheduleLocationState }
}
